import du from '../utils/dom-utilities';
import scrollTo from '../utils/ScrollTo';

export default class ScrollToTop {
    constructor(){
    }
    init(selector) {
        du.queryAll(selector).forEach(function(elem){
            du.onEvent(elem, 'click', function(event){
                event.preventDefault();
                scrollTo(document.scrollingElement || document.documentElement, 0, 400);
            });
        });
    }
};



// WEBPACK FOOTER //
// ./src/main/js/components/ScrollToTop.js